import { dmWatcher } from 'mastodon/initial_state';

import { urlRegex } from './url_regex';

const urlPlaceholder = '$2xxxxxxxxxxxxxxxxxxxxxxx';

export function countableText(inputText) {
  return inputText
    .replace(urlRegex, urlPlaceholder)
    .replace(/(^|[^/\w])@(([a-z0-9_]+)@[a-z0-9.-]+[a-z0-9]+)/ig, '$1@$3');
}

/**
 * Removes the "@admin " the server puts in front of private mentions during
 * an "include the admin" period, which does not count toward the limit.
 * @param {string} inputText The text of the post
 * @param {string} privacy The visibility of the post
 * @param {string | null} [watcher] The username added to private mentions
 * @returns {string} The text without that prefix
 */
export function withoutWatcherPrefix(inputText, privacy, watcher = dmWatcher) {
  if (privacy !== 'direct' || !watcher) return inputText;

  const escaped = watcher.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  return inputText.replace(new RegExp(`^@${escaped}(@[a-z0-9.-]+)?\\s+`, 'i'), '');
}
